// 50+ homepage FAQs targeting real "People Also Ask" / search queries.
// Used for the on-page accordion AND the FAQPage JSON-LD schema.
export const HOME_FAQS = [
  {
    q: "Which is the best animal pathology lab in Kolkata?",
    a: "Animal Analytics is widely regarded as one of the best and most trusted pet pathology labs in Kolkata and West Bengal. Operating since 2012, we provide accurate blood tests, urine tests, stool tests and full diagnostics for dogs, cats and all pets, with free home sample collection across Kolkata."
  },
  {
    q: "Is there a pet pathology lab near me in Kolkata?",
    a: "Yes. Animal Analytics serves all of Kolkata with home sample collection, so you do not need to travel. Wherever you are in the city, we send a trained person to collect your pet's sample from your home and deliver the report on WhatsApp or email."
  },
  {
    q: "How much does a dog blood test cost in Kolkata?",
    a: "Dog blood test prices vary by the panel needed, such as CBC, biochemistry, or a tick-fever panel. We do not fix a flat rate because every case is different. WhatsApp or call us with your requirement and we will share an honest, exact cost upfront."
  },
  {
    q: "What is the price list for pet pathology tests?",
    a: "Pricing depends on the specific test, the animal, and the number of parameters. Rather than a misleading fixed list, we give you an exact quote for your pet's needs. Message us on WhatsApp with the test name or your vet's prescription for an accurate price."
  },
  {
    q: "Do you offer home sample collection for pet blood tests?",
    a: "Yes. Home sample collection is our primary service across Kolkata. Share your address on WhatsApp and we arrange collection of blood, urine or stool samples from your home, so your pet stays calm and comfortable."
  },
  {
    q: "What is a CBC test for dogs and why is it done?",
    a: "A CBC (Complete Blood Count) measures red cells, white cells and platelets to detect infection, anaemia, inflammation and many other conditions. It is the most common first-line dog blood test and is often advised before treatment or surgery."
  },
  {
    q: "Can I get a dog blood test report on the same day?",
    a: "Many routine tests like CBC are processed quickly and reports are typically shared the same day on WhatsApp or email. For specialised panels, we tell you the exact turnaround time when you book."
  },
  {
    q: "What animals do you test at Animal Analytics?",
    a: "We test all pets: dogs, cats, rabbits, guinea pigs, birds, parrots, hamsters and pet turtles. If your companion animal needs an accurate diagnosis, we can help."
  },
  {
    q: "Do you provide cat blood tests and diagnostics?",
    a: "Yes. We provide complete cat diagnostics including CBC, biochemistry, FIV/FeLV screening, kidney and liver panels, urine and stool analysis, with home sample collection across Kolkata."
  },
  {
    q: "What is the cost of a dog tick fever test?",
    a: "Tick-fever (Ehrlichia, Anaplasma, Babesia) panels are priced by the specific test method used. Contact us with your vet's advice and we will share the exact cost and arrange home collection."
  },
  {
    q: "How do I book a pet pathology test in Kolkata?",
    a: "Simply WhatsApp or call us. Tell us your pet's problem or share the prescribed tests, and we schedule home sample collection at a time that suits you."
  },
  {
    q: "Which tests are needed for a sick dog?",
    a: "Commonly a CBC, biochemistry (liver and kidney), and a tick-fever panel are advised for a sick dog, along with urine or stool tests if needed. We guide you based on symptoms and your vet's advice."
  },
  {
    q: "Do you do urine tests for dogs and cats?",
    a: "Yes. We perform routine urine examination and urine culture for dogs and cats to check for urinary infections, kidney issues, crystals and more, with home sample collection."
  },
  {
    q: "Do you do stool tests for pets?",
    a: "Yes. We carry out stool (faecal) tests to detect worms, parasites, protozoa and digestive problems in dogs, cats and other animals."
  },
  {
    q: "Are your pet test reports accepted by veterinarians?",
    a: "Yes. Our reports are accurate, standardised and trusted by veterinarians across West Bengal, who refer their cases to us regularly."
  },
  {
    q: "Is Animal Analytics a trusted pet diagnostic lab?",
    a: "Yes. Since 2012 we have built our reputation on accuracy and honesty, with no commission arrangements. Veterinarians and pet owners across Kolkata and West Bengal trust our reports."
  },
  {
    q: "What is the best place for a dog diagnostic test in Kolkata?",
    a: "Animal Analytics is a top choice for dog diagnostic tests in Kolkata, offering accurate results, fair pricing and convenient home sample collection across the city."
  },
  {
    q: "Do you provide diagnostic services outside Kolkata in West Bengal?",
    a: "Yes. We serve all of West Bengal. Outstation samples reach us by courier and we guide every client personally on safe sample handling and dispatch."
  },
  {
    q: "What is the turnaround time for pet test reports?",
    a: "Routine tests are usually reported the same day, while specialised panels may take longer. We confirm the exact timing at the time of booking."
  },
  {
    q: "Do you need a vet prescription for a pet blood test?",
    a: "A prescription is helpful but not always required. You can share your pet's symptoms with us and we will guide you on the right tests, or simply send your vet's advised list."
  },
  {
    q: "What is included in a dog full body checkup or health panel?",
    a: "A general health panel typically includes CBC and biochemistry covering liver, kidney, glucose and electrolytes. We tailor the panel to your dog's age and condition."
  },
  {
    q: "How accurate are your pet pathology test results?",
    a: "Accuracy is our priority. Every report is treated as if it were for our own pet, because a wrong diagnosis can cost an animal its life."
  },
  {
    q: "Can you collect a sample from my home at a specific time?",
    a: "Yes. We schedule home sample collection at a time convenient for you. Share your address and preferred slot on WhatsApp."
  },
  {
    q: "Do you test rabbits and guinea pigs?",
    a: "Yes. We provide diagnostics for rabbits and guinea pigs, with home sample collection across Kolkata."
  },
  {
    q: "Do you test pet birds and parrots?",
    a: "Yes. We provide avian pathology for pet birds and parrots, with home sample collection."
  },
  {
    q: "Do you test pet turtles and reptiles?",
    a: "Yes. We offer diagnostics for pet turtles and reptiles, guiding you on safe sample collection."
  },
  {
    q: "What is a biochemistry test for pets?",
    a: "A biochemistry panel checks organ function, including liver enzymes, kidney values, glucose and electrolytes, helping understand what is happening inside your pet."
  },
  {
    q: "Can you test for parvovirus and distemper in dogs?",
    a: "Yes. We provide serology and rapid screening for parvovirus, distemper and other infectious diseases in dogs."
  },
  {
    q: "How do I get my pet's blood test report?",
    a: "Reports are delivered directly to you on WhatsApp or email as soon as they are ready, so there is no need to travel to collect them."
  },
  {
    q: "Why are some pet labs cheaper than others?",
    a: "Very low prices can mean lower quality reagents or shortcuts that affect accuracy. We focus on reliable, accurate results at a fair, transparent price."
  },
  {
    q: "Do you charge extra for home sample collection?",
    a: "We keep home collection convenient and affordable across Kolkata. Contact us and we will tell you the exact cost for your area upfront."
  },
  {
    q: "What should I do if my dog is vomiting or not eating?",
    a: "Contact your vet, and arrange a CBC and biochemistry panel to identify the cause. We can collect the sample from your home quickly and report promptly."
  },
  {
    q: "Do you provide pre-surgery blood tests for pets?",
    a: "Yes. Pre-anaesthetic and pre-surgery panels are available to check your pet is fit for a procedure, with home sample collection."
  },
  {
    q: "Can you test senior dogs and cats for age-related issues?",
    a: "Yes. Senior pet panels screen kidney, liver, thyroid and other parameters that commonly change with age, helping catch problems early."
  },
  {
    q: "How experienced is Animal Analytics?",
    a: "We have provided animal and pet pathology services since 2012, building over a decade of experience and trust across Kolkata and West Bengal."
  },
  {
    q: "Do you have commission tie-ups with vets?",
    a: "No. We have never had commission arrangements. Your report reflects only what the science shows, which is why our results are trusted."
  },
  {
    q: "Which areas of Kolkata do you cover for home collection?",
    a: "We cover all of Kolkata including Sovabazar, Shyambazar, Salt Lake, New Town, Behala, Tollygunge, Garia, Jadavpur, Howrah, Dum Dum, Barasat and many more areas."
  },
  {
    q: "Can I get a dog blood test price in Kolkata before booking?",
    a: "Yes. We give you the exact price before you book. Just WhatsApp the test name or your prescription and we respond with an honest quote."
  },
  {
    q: "What is FNAC or biopsy testing for pets?",
    a: "FNAC and biopsy (cytology and histopathology) examine lumps, growths and lesions to determine whether they are benign or need further treatment."
  },
  {
    q: "Do you offer culture and sensitivity tests?",
    a: "Yes. We perform microbiology culture and sensitivity testing to identify infections precisely so the right antibiotic can be chosen."
  },
  {
    q: "How quickly do you respond on WhatsApp?",
    a: "We typically respond within minutes during our working hours of 7AM to 10PM, every day."
  },
  {
    q: "What are your working hours?",
    a: "We are open from 7AM to 10PM, every day of the week, and personally attend every call and WhatsApp message within those hours."
  },
  {
    q: "Is Animal Analytics good for rabbits, birds and small pets?",
    a: "Yes. We provide diagnostics for rabbits, guinea pigs, birds, parrots, hamsters and pet reptiles, with home sample collection across Kolkata."
  },
  {
    q: "What makes you the top pet pathology lab in West Bengal?",
    a: "Our accuracy, honest pricing, decade of experience, vet trust and convenient home sample collection make us a top pet pathology lab in West Bengal."
  },
  {
    q: "Can you help if I do not know which test my pet needs?",
    a: "Yes. Describe your pet's symptoms on WhatsApp or call us, and we will guide you on exactly which tests are needed, nothing more."
  },
  {
    q: "Do you provide reports in a format my vet can read?",
    a: "Yes. Reports are clear, standardised and easy for any veterinarian to interpret, and we share them digitally."
  },
  {
    q: "How do I get a dog diagnostic test done without going to a lab?",
    a: "Choose home sample collection. We come to your home, collect the sample, and send the report to you digitally, so no lab visit is needed."
  },
  {
    q: "Do you test for kidney and liver problems in pets?",
    a: "Yes. Our biochemistry panels assess kidney (urea, creatinine) and liver (SGPT, SGOT) function in dogs, cats and other animals."
  },
  {
    q: "Why should I choose Animal Analytics over other pet labs?",
    a: "Because we combine accuracy, honesty, over a decade of experience, vet trust and convenient home sample collection across Kolkata and West Bengal."
  },
  {
    q: "How can I contact Animal Analytics?",
    a: "Call or WhatsApp us directly. We pick up personally between 7AM and 10PM, every day, and arrange home sample collection wherever you are in Kolkata."
  }
];
